module.exports = __webpack_public_path__ + "static/media/atas-logo.2dfda2af.png";